import { _checkProdIsFiltered } from './spaces_aux_calc_prod_data';
import { _cloneDeep } from '@shared/aux_helper_functions';
import { _normaliceProdFilters } from './spaces_aux_helpers';
import { _hasExhibitionViewFilter } from './spaces_aux_planogram_prod_exhibition';

const _sortedIds = (arr: any[]) => (arr || []).map(String).sort().join(',');

/** Filtros del panel avanzado que acotan la vista del menú (categoría/tag), no el alcance del planograma. */
export const _hasProdListViewFilters = function (filters, defaultFilters = null) {
  const f = _normaliceProdFilters(filters);
  if (!f || !Object.keys(f).length) return false;

  if (f.selectedTags?.length) return true;
  if (f.categories?.length) return true;

  if (f.subCategories?.length) {
    const def = defaultFilters ? _normaliceProdFilters(defaultFilters) : null;
    if (!def?.subCategories?.length) return true;
    if (_sortedIds(f.subCategories) !== _sortedIds(def.subCategories)) return true;
  }

  return false;
};

/** Filtros exhibido/no exhibido: solo frontend, no consultan al backend (CATMAN-B013/B016). */
export const _hasFrontendOnlyProdListFilters = function (filters) {
  return _hasExhibitionViewFilter(filters);
};

export const _canApplyProdListFromCache = function (filters, defaultFilters = null, scopeCacheLength = 0) {
  return scopeCacheLength > 0 && (_hasProdListViewFilters(filters, defaultFilters) || _hasFrontendOnlyProdListFilters(filters));
};

export const _filterProdListByViewFilters = function (items, filters, defaultFilters = null) {
  if (!items?.length) return [];
  const normalized = _normaliceProdFilters(filters);
  if (!_hasProdListViewFilters(normalized, defaultFilters)) return items;

  return items.filter(item => {
    const prod = item?.itemData ? item : { itemData: item };
    return !_checkProdIsFiltered(prod, normalized);
  });
};

/** Aplica filtros de vista sobre la caché del alcance; la caché completa no se pierde. */
export const _applyProdListViewFromCache = function (prodList, newFilters, defaultFilters = null) {
  const def = defaultFilters || prodList?.defaultFilters || {};
  const cache = prodList?.prodListdataScopeCache?.length > 0 ? prodList.prodListdataScopeCache : prodList?.prodListdata || [];

  const normalized = _normaliceProdFilters(newFilters);
  const hasView = _hasProdListViewFilters(normalized, def);
  const prodListdata = hasView ? _filterProdListByViewFilters(cache, normalized, def) : _cloneDeep(cache);
  const totalItemsScope = prodList?.totalItemsScope ?? prodList?.totalItems ?? cache.length;

  return {
    prodListdata,
    totalItems: hasView ? prodListdata.length : totalItemsScope,
    totalItemsScope,
    hasView,
    cacheLength: cache.length,
  };
};
